/**
 * 数组比较
 * @param {*} arr1
 * @param {*} arr2
 * @returns
 */
export function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
}

export function replaceBrWithNewline(input) {
  const result = input.replace(/<br>/g, '\n').replace(/`/g, '');
  return `${result}`;
}

/**
 * 2023-10-19T19:23:25Z  ---> 2023.10.25
 * @param {*} dateString
 * @returns
 */
export function formatDate(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${year}.${month}.${day}`;
}
export function getLocale() {
  let locale = 'en';
  let domain = window.location.hostname;

  if (domain === 'inhand.com.cn' ) {
    return 'cn';
  } else {
    let url = window.location.href;
    const path = new URL(url).pathname;
    const languages = ['en', 'fr', 'es', 'de'];

    for (const item of path.split('/')) {
      if (languages.includes(item)) {
        return item;
      }
    }
  }

  return locale;
}
/**
 * B、KB、MB
 * @param {*} data
 * @returns
 */
export function formatData(data) {
  if (data < 1024) {
    return `${data} B`;
  } else if (data < 1024 * 1024) {
    const dataSizeKB = (data / 1024).toFixed(2);
    return `${dataSizeKB} KB`;
  } else {
    const dataSizeMB = (data / (1024 * 1024)).toFixed(2);
    return `${dataSizeMB} MB`;
  }
}
